import isType from './is-type';
export default (function (str) {
    return isType(str, 'String');
});
//# sourceMappingURL=is-string.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-string.js
// module id = 49
// module chunks = 3